export default __webpack_public_path__ + "images/0x82b0e1a2374ea0198f62a48b14ffab53db6c1e36.png";